export enum InsightErrorType {
  SUBSCRIPTION_ERROR = 'SUBSCRIPTION_ERROR',
  BFF_ERROR = 'BFF_ERROR',
  RENDER_ERROR = 'RENDER_ERROR',
  OTHER = 'OTHER',
  EXPIRED = 'EXPIRED',
  MULTI_CONFIG_ERROR = 'MULTI_CONFIG_ERROR',
}
export interface ErrorInfo {
  errorType: InsightErrorType
  loggerMessage: string
  userMessage?: string
}
